import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import { useTranslation } from "react-i18next";
import { CaseCopyForm } from "src/forms/CaseCopyForm";

import { useCopyCase, type CaseCopyMutationData } from "src/hooks/caseHooks";

export function CaseCopyDialog(props: { open: boolean; caseId: number; onClose: () => void }) {
  const { t } = useTranslation();
  const { mutateAsync: copyCase, isLoading, error } = useCopyCase(props.caseId);

  function handleSubmit(values: CaseCopyMutationData) {
    copyCase(values.caseName).then(() => {
      props.onClose();
    });
  }

  return render();

  function render() {
    return (
      <Dialog open={props.open}>
        <DialogTitle>{t("label.copyCase")}</DialogTitle>
        <DialogContent>
          <CaseCopyForm
            onClose={props.onClose}
            onSubmit={handleSubmit}
            isLoading={isLoading}
            errors={error?.response?.data}
          />
        </DialogContent>
      </Dialog>
    );
  }
}
